import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "app-rayalina-login-form",
    templateUrl: "./login-form.component.html",
    styleUrls: ["./login-form.component.scss"],
})
export class RayalinaLoginFormComponent {
    @Input() returnUrl: string | null = null;
    @Output() readonly success = new EventEmitter<void>();

    isShowPass = false;
    formSubmitted = false;
    errorMessage: string | null = null;
    loading = false;

    loginForm = new FormGroup({
        email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
        password: new FormControl<string | null>(null, [
            Validators.required,
            Validators.minLength(6),
        ]),
    });

    constructor(private readonly auth: AuthService) {}

    handleShowPass(): void {
        this.isShowPass = !this.isShowPass;
    }

    onSubmit(): void {
        this.errorMessage = null;
        this.formSubmitted = true;
        if (!this.loginForm.valid) {
            return;
        }
        const { email, password } = this.loginForm.getRawValue();
        this.loading = true;
        this.auth.login(email!, password!).subscribe({
            next: () => {
                this.loading = false;
                if (this.success.observed) {
                    this.success.emit();
                    return;
                }
                this.auth.navigateAfterAuth(this.returnUrl);
            },
            error: (err) => {
                this.loading = false;
                this.errorMessage =
                    typeof err?.error === "string"
                        ? err.error
                        : "Connexion impossible. Vérifiez votre email, mot de passe et la configuration de l’API.";
            },
        });
    }

    get email() {
        return this.loginForm.get("email");
    }

    get password() {
        return this.loginForm.get("password");
    }
}
